import { useAppConfig } from "@/appConfig";
import { useCurrentWebsite } from "./useCurrentWebsite";

// Product gate for the Genie/Copilot chat, which belongs to The Buyer
// Listing Service and must never surface on Gitcha.
//
// Two conditions, deliberately. `RequireAuth roles={[2]}` is NOT a product
// gate - Gitcha has agents too, so a role check alone would let Copilot
// through on gitcha.com. And tenant id alone would ship it to every BLS
// tenant the moment it merges, with no way to stage a rollout.
//
//   tenant id !== "default"  ->  this is a BLS tenant, not Gitcha
//   featureFlags.copilot     ->  this particular tenant has it on
//
// Mirrors the existing idiom in SendIntroduction.js:
//   !isGitchaDefaultWebsite && !!flags?.mlsListings
export const useCopilotEnabled = () => {
  const { isGitchaDefaultWebsite, mls: tenantId } = useCurrentWebsite();
  const { flags } = useAppConfig() || {};
  // Defensive: AppConfigProvider doesn't render children until the tenant
  // resolves, so tenantId is never unset here in practice. Kept as a second
  // line of defense against Copilot surfacing on Gitcha.
  if (!tenantId || isGitchaDefaultWebsite) return false;
  return !!flags?.copilot;
};
